import React from "react";
import { VCredit } from "./VCredit";
import { KenoHitGem } from "./KenoHitGem";
import { KenoPayoutBar } from "./KenoPayoutBar";

export const KenoBoard = ({ game }) => {
  return (
    <section className="keno-stage" aria-label="Keno number board" data-testid="keno-stage">
      <div className="keno-stage-heading"><span data-testid="keno-selected-count">{game.selected.length} / 10 selected</span></div>
      <div className="keno-number-board">
      <div className="keno-number-grid" data-testid="keno-number-grid">
        {Array.from({ length: 40 }, (_, index) => index + 1).map((number) => {
          const selected = game.selected.includes(number);
          const drawn = game.drawn.includes(number);
          const hit = selected && drawn;
          return <button key={number} data-testid={`keno-tile-${number}`} data-selected={selected} data-drawn={drawn} data-hit={hit}
            className={`keno-tile ${selected ? "is-selected" : ""} ${drawn ? "is-drawn" : ""} ${hit ? "is-hit" : ""}`}
            onClick={() => game.toggle(number)} disabled={game.busy || game.auto || game.picking || (!selected && game.selected.length >= 10)}
            aria-pressed={selected} aria-label={`Number ${number}${hit ? ", hit" : drawn ? ", drawn" : ""}`}>
            <span>{number}</span>{hit && <KenoHitGem />}
          </button>;
        })}
      </div>
      {game.result?.payout_minor > game.result?.bet_minor && <div className="keno-win-overlay" data-testid="keno-win-overlay" role="status">
        <strong data-testid="keno-win-multiplier">{game.result.multiplier.toFixed(2)}×</strong>
        <div className="keno-win-divider" aria-hidden="true" />
        <span className="keno-win-amount"><VCredit minor={game.result.payout_minor} demo={game.result.currency === 'demo'} testid="keno-win-payout" /></span>
      </div>}
      </div>
      <KenoPayoutBar game={game} />
      <div className="keno-round-status" role="status" aria-live="polite" data-testid="keno-round-status">
        {game.busy && !game.result ? <span>Drawing {game.drawn.length} / 10</span> : game.result ? <><span>{game.result.matches} {game.result.matches === 1 ? "hit" : "hits"} · {game.result.multiplier}×</span><span className={game.result.payout_minor > 0 ? "keno-return-positive" : ""}>Returned <VCredit minor={game.result.payout_minor} demo={game.result.currency === 'demo'} testid="keno-round-return" /></span></> : null}
      </div>
      {game.error && <p role="alert" data-testid="keno-error" className="keno-error">{game.error}</p>}
    </section>
  );
};